import Velocity from 'velocity-animate';

export default class Transition {
  // Settings are mostly here to manage all panel based transitions,
  // this includes wallpaper and transfer window move for full-panel.
  // NOTE: Some of these settings are actually also in CSS.. I know, convenient.
  settings = {
    mobileHA: true,
    duration: 500, // .5s
    easing: [0.77, 0.0, 0.175, 1.0], // [cubic bezier]
  };

  // Our Transition constructor decides what callbacks to do when.
  constructor(props) {
    // transfer = false (no panel)
    if (props.prevType === 'transfer') {
      props.prevType = false;
    }

    if (props.newType === 'transfer') {
      props.newType = false;
    }

    if (props.prevType === props.newType) {
      return;
    }

    // Set transition properties
    this.component = props.component;
    this.animate = props.animate !== false;
    this.animating = this.animate;
    this.onComplete = props.complete;

    // Stop any running animations
    this.stop();
    this.component.classList.remove('panel--animating');

    // What animation are we doing now?
    let promises = [];

    if (!props.prevType && props.newType === 'page') {
      promises = this.hiddenToPage();
    } else if (!props.prevType && props.newType === 'plus') {
      promises = this.hiddenToPlus();
    } else if (props.prevType === 'plus' && props.newType === 'page') {
      promises = this.plusToPage();
    } else if (props.prevType === 'page' && props.newType === 'plus') {
      promises = this.pageToPlus();
    } else if (!props.newType) {
      promises = this.anyToHidden();
    }

    // When all animations are finishes, call the complete handler
    Promise.all(promises)
      .then(() => (this.animating = false))
      .then(this.onComplete);
  }

  // Stop the transition (for panel, or for Velocity)
  stop(panelInitiated = false) {
    if (!panelInitiated) {
      Velocity(this.component, 'stop', true);
    } else {
      if (this.exitTimeout) {
        clearTimeout(this.exitTimeout);
      }

      if (this.exitResolve) {
        this.exitResolve();
      }
    }
  }

  hiddenToPage() {
    const makeVisible = () => this.component.classList.add('panel--visible');

    const setClass = () => {
      this.component.className =
        'panel panel--full' + (!this.animate ? ' panel--no-transition' : '');
      this.component.classList.add('panel--animating');

      // This 1ms feels hacky but is needed for the some browsers, otherwise
      // they will mess up the width + transform transition at the same time.
      if (this.animate) {
        setTimeout(makeVisible, 1);
      } else {
        makeVisible();
      }
    };

    if (!this.animate) {
      setClass();
    }

    return [
      new Promise((resolve) => {
        if (this.animate) {
          setClass();
        }
        setTimeout(
          () => this.component.classList.remove('panel--animating'),
          this.settings.duration
        );
        this.exitResolve = resolve;
        this.exitTimeout = setTimeout(resolve, this.settings.duration);
      }),
    ];
  }

  hiddenToPlus() {
    const makeVisible = () => this.component.classList.add('panel--visible');

    const setClass = () => {
      this.component.className =
        'panel panel--half' + (!this.animate ? ' panel--no-transition' : '');
      this.component.classList.add('panel--animating');

      // This 1ms feels hacky but is needed for the some browsers, otherwise
      // they will mess up the width + transform transition at the same time.
      if (this.animate) {
        setTimeout(makeVisible, 1);
      } else {
        makeVisible();
      }
    };

    if (!this.animate) {
      setClass();
    }

    return [
      new Promise((resolve) => {
        if (this.animate) {
          setClass();
        }
        setTimeout(
          () => this.component.classList.remove('panel--animating'),
          this.settings.duration
        );
        this.exitResolve = resolve;
        this.exitTimeout = setTimeout(() => {
          resolve();
        }, this.settings.duration);
      }),
    ];
  }

  plusToPage() {
    this.component.className = 'panel panel--visible panel--full';
    this.component.classList.add('panel--animating');

    return [
      new Promise((resolve) => {
        setTimeout(() => {
          this.component.classList.remove('panel--animating');
          resolve();
        }, this.settings.duration);
      }),
    ];
  }

  pageToPlus() {
    this.component.className = 'panel panel--visible panel--half';
    this.component.classList.add('panel--animating');

    return [
      new Promise((resolve) => {
        setTimeout(() => {
          this.component.classList.remove('panel--animating');
          resolve();
        }, this.settings.duration);
      }),
    ];
  }

  anyToHidden() {
    this.component.classList.remove('panel--no-transition');
    this.component.classList.add('panel--hidden');

    return [
      new Promise((resolve) => {
        this.exitResolve = resolve;
        this.exitTimeout = setTimeout(resolve, this.settings.duration);
      }),
    ];
  }
}
